<template>
  <section class="fo-card">
    <div class="fo-card-loading loading loading-lg" v-if="loading"></div>
    <div class="fo-card-head">
      <h2 class="fo-card-title">
        Maiores despesas<small>{{ regimeLabel }}</small>
      </h2>
      <div class="fo-segment fo-segment-sm" role="group" aria-label="Agrupar despesas">
        <button type="button" :class="{ 'is-active': groupBy === 'categories' }"
                @click="groupBy = 'categories'">Categoria</button>
        <button type="button" :class="{ 'is-active': groupBy === 'entities' }"
                @click="groupBy = 'entities'">Favorecido</button>
      </div>
    </div>

    <div class="fo-expenses" v-if="rows.length > 0">
      <div class="fo-expense" v-for="row in rows" :key="row.name">
        <div class="fo-expense-head">
          <strong :title="row.name">{{ row.name }}</strong>
          <span class="fo-expense-values">
            <span class="fo-num">{{ percent(row.share) }}</span>
            <span class="fo-line-value">{{ money(row.value) }}</span>
          </span>
        </div>
        <div class="fo-expense-track">
          <span :style="{ width: `${(row.value / rows[0].value) * 100}%` }"></span>
        </div>
      </div>
    </div>
    <div class="fo-empty" v-else>
      <fa-icon :icon="['fal', 'check']"/>
      <strong>Sem despesas no período</strong>
      <span>{{ emptyReason }}</span>
    </div>

    <div class="fo-card-foot">
      <span>Total de despesas do período</span>
      <strong>{{ money(expenses.total) }}</strong>
    </div>
  </section>
</template>

<script>
import { money, percent } from './helpers';

export default {
  props: {
    expenses: {
      type: Object,
      required: true,
    },
    regime: {
      type: String,
      default: 'competence',
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      groupBy: 'categories',
    };
  },
  computed: {
    rows() {
      return (this.expenses[this.groupBy] || []).filter(row => row.value > 0);
    },
    regimeLabel() {
      return this.regime === 'cash' ? 'pagas no período' : 'por competência';
    },
    emptyReason() {
      return this.regime === 'cash'
        ? 'Nenhuma despesa paga nessas datas.'
        : 'Nenhuma despesa com competência nessas datas.';
    },
  },
  methods: {
    money(value) {
      return money(value, this.hidden);
    },
    percent,
  },
};
</script>
